import { Box, Container, Grid, Stack } from '@mui/material'
import { HottestBlogs } from './HottestBlogs'
import { NewlyUpdatedBlogs } from './NewlyUpdatedBlogs'
import { Reel } from './Reel'

import { ContainerCustom, Image } from '@/components'
import { AdsBlogs } from './AdsBlogs'
import { getBlogPostsByCategory } from '../services'
import Link from '@/features/ref/components/Link'

export const BlogContainer = async () => {
  const dataHottestBlog = await getBlogPostsByCategory({
    categoryId: 6,
    pageSize: 4,
    currentPage: 1,
    action: 'get_post_list',
    sortBy: 'Latest',
  })
  const parseDataHottestBlog = dataHottestBlog?.data?.items || []
  return (
    <ContainerCustom sx={{ minHeight: '100vh', paddingTop: '1rem', margin: '0 auto' }}>
      <Grid container spacing={2} sx={{ padding: { xs: '0 0 42px', md: '0 0 96px' } }}>
        <Grid size={{ xs: 12, md: 4, xl: 3 }} order={{ xs: 2, md: 1 }}>
          <Box sx={{ position: 'sticky', top: '32px' }}>
            <HottestBlogs data={parseDataHottestBlog}>
              <AdsBlogs />
            </HottestBlogs>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 8, xl: 6 }} order={{ xs: 1, md: 2 }}>
          <Stack spacing={{ lg: 8, md: 6, xs: 4 }}>
            <Reel />
            {/* Banner */}
            <Link target="_blank" href={'/danh-muc-san-pham/'} rel="noreferrer">
              {' '}
              <Image
                src={'/assets/images/temp_decor_blog/decor-ad-2.jpg'}
                alt="Banner"
                sx={{
                  borderRadius: '8px',
                }}
              />
            </Link>
            <NewlyUpdatedBlogs />
          </Stack>
        </Grid>
        <Grid sx={{ display: { xs: 'none', xl: 'block' } }} size={{ xs: 12, md: 6, xl: 3 }} order={{ xs: 3 }}>
          <Stack spacing={2} sx={{ position: 'sticky', top: '32px' }}>
            <AdsBlogs />
          </Stack>
        </Grid>
      </Grid>
    </ContainerCustom>
  )
}
